module.exports = __webpack_public_path__ + "img/432.eccc6af7.jpg";